import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-select-check-all',
    templateUrl: './select-check-all.component.html',
    standalone: true,
    styles: [
        `
            /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
            app-select-check-all .mat-checkbox-layout,
            app-select-check-all .mat-checkbox-label {
                width: 100% !important;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [MatCheckboxModule],
})
export class SelectCheckAllComponent {
    @Input() model: AbstractControl;
    @Input() values = [];
    @Input() text = 'Välj alla';
    @Input() color = 'primary';
    @Input() property;

    isChecked(): boolean {
        return this.model?.value?.length === this.values?.length;
    }

    isIndeterminate(): boolean {
        return this.model?.value?.length < this.values?.length && this.model?.value?.length > 0;
    }

    toggleSelection(change: MatCheckboxChange): void {
        if (change.checked) {
            this.model.setValue(this.property ? this.values.map((v) => v[this.property]) : this.values);
        } else {
            this.model.setValue([]);
        }
    }
}
